import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getCapitoliCount = (id) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/capitoli/count';
  let query = PATH + '?manualeId.equals=' + id;
  const URL = BASE_URL + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const getCapitoli = (manualeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/capitoli';
  let query = '?manualeId.equals=' + manualeId;
  query = query + '&page=0&size=1000&sort=numeroCapitolo,ASC';
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const putCapitoli = (body) => {
  const token = retrieveToken();
  const PATH = '/api/capitoli';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(body),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Salvataggio non riuscito: il manuale o un suo capitolo non esiste più. Ricaricare la pagina.',
    }),
  );
};
